import { useContext } from 'react';
import { DateValue, parseDate } from '@internationalized/date';
import { DatePickerStateContext } from 'react-aria-components';

import { attempt } from '@page/core/utils/function';

export const useDatePickerContext = () => {
  const state = useContext(DatePickerStateContext);

  if (!state) throw new Error('DatePickerStateContext is not provided');

  return state;
};

export const parseToDateValue = (value: Date | string | null | undefined): DateValue | null => {
  if (!value) return null;

  if (typeof value === 'string') {
    const [error, date] = attempt(() => parseDate(value));

    if (error) {
      console.error('Error parsing date', error);

      return null;
    }

    return date;
  }

  return parseDate(value.toISOString());
};

export const isDateInRange = (date: DateValue, minValue?: DateValue, maxValue?: DateValue): boolean => {
  if (minValue && date.compare(minValue) < 0) return false;

  if (maxValue && date.compare(maxValue) > 0) return false;

  return true;
};
